// extracted by mini-css-extract-plugin
var _1 = "spinner";
var _2 = "spinner--alternate";
var _3 = "spinner--large";
var _4 = "spinner--logo";
var _5 = "spinner--small";
export { _1 as "spinner", _2 as "spinnerAlternate", _3 as "spinnerLarge", _4 as "spinnerLogo", _5 as "spinnerSmall" }
